import React from "react";
import GridItem from "../../../components/Grid/GridItem";
import CustomRadio from "../../../components/CustomRadio/CustomRadio";
import { clone } from "../../../shared/utility";

const LeaseRangesBasedOff = props => {
    const { data, setData } = props;
    return <GridItem xs={12} sm={3} md={3}>
        <CustomRadio 
            value={data.lease_ranges_based_off === 'Rent Commencement Date' ? data.lease_ranges_based_off : 'Lease Start Date'}
            options={['Lease Start Date','Rent Commencement Date']}
            label="Lease Ranges Based Off,Lease Start Date,Rent Commencement Date"
            onChange={(e,a,b) => {
                console.log(e,a,b);
                const clonedData = clone(data);
                clonedData.lease_ranges_based_off = a;
                setData(clonedData);
            }}
        />
    </GridItem>
}

export default LeaseRangesBasedOff;